import axios, { getEnv } from './api';

const xlsService = {
    xlsDownload: async (body, fileName, callback = () => {
    }) => {
        axios
            .post(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/integracao/docs/excel?primaria=WHITE&secundaria=GREY_25_PERCENT&terciaria=WHITE`,
                body,
                {
                    responseType: 'blob',
                }
            )
            .then((response) => {
                const aElement = document.createElement('a');
                aElement.setAttribute('download', `${fileName}.xlsx`);
                const href = URL.createObjectURL(response.data);
                aElement.href = href;
                aElement.setAttribute('target', '_blank');
                aElement.click();
                URL.revokeObjectURL(href);
                callback();
            })
            .catch((erro) => {
                alert('Algo deu errado: ' + erro);
            });
    },
    xlsDownloadCsv: async (body, fileName, callback = () => {
    }) => {
        try {
            const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/integracao/docs/csv`, body, {responseType: 'blob'})
            const aElement = document.createElement('a');
            aElement.setAttribute('download', `${fileName}.csv`);
            const href = URL.createObjectURL(response.data);
            aElement.href = href;
            aElement.setAttribute('target', '_blank');
            aElement.click();
            URL.revokeObjectURL(href);
            callback();
        } catch (erro) {
            throw erro;
        }
    },

    xlsDownloadSSE: async (body, fileName, callback = () => {
    }) => {
        try {
            const response = await axios.post(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/nan/csv/atendimentos`,
                body,
                {responseType: 'blob'}
            );
            const aElement = document.createElement('a');
            aElement.setAttribute('download', `${fileName}.csv`);
            const href = URL.createObjectURL(response.data);
            aElement.href = href;
            aElement.setAttribute('target', '_blank');
            aElement.click();
            URL.revokeObjectURL(href);
            callback();
        } catch (erro) {
            throw erro;
        }
    },
};

export default xlsService;
